import { setGlobals } from '../../utils/global-variables';

class {
    onCreate(input, out) {
        setGlobals(input.model);
    }
}

<noscript class="str-global-variables"></noscript>
